import { isown, symbolsof, valueof } from "~/utils/iterate-object/object";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* iterateObjectValue(o: any) {
	for (const key in o) {
		const value = valueof(o, key);
		if (!isown(o, key)) {
			continue;
		}

		yield [key, value] as const;
	}

	for (const symbol of symbolsof(o)) {
		const value = valueof(o, symbol);
		yield [symbol, value] as const;
	}
}
